import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registrarTap} from "../api";

const SugerenciaItem = ({ comercio, estaLogueado, handleToggleSeguir }) => {
  const navigate = useNavigate();
  const [logoCargado, setLogoCargado] = useState(false);
  const seguidoBool = !!comercio.seguido;

  const irADetalle = () => {
    const id_perfil = localStorage.getItem("id_perfil");
    const id_sucursal = comercio.id_sucursal;

    registrarTap(id_sucursal, "home_vip", id_perfil);

    setTimeout(() => {
      navigate(`/comercio/${comercio.id}/${id_sucursal}`);
    }, 200);
  };

  return (
    <div className="suggestion-item" onClick={irADetalle}>
      {!logoCargado && <div className="logo-skeleton" />}
      <img
        src={comercio.logo}
        alt={comercio.nombre}
        loading="lazy"
        style={{
          visibility: logoCargado ? "visible" : "hidden",
          position: logoCargado ? "static" : "absolute"
        }}
        onLoad={() => setLogoCargado(true)}
      />

      <div className="suggestion-info">
        <h4>
          {comercio.nombre}
          <img
            src="/assets/images/verified.svg"
            className="verifiedUser"
            loading="lazy"
            style={{ width: 16 }}
            alt="Verificado"
          />
        </h4>
        <p>
          {comercio.online == 1 ? (
            <><span style={{color:"#9FD158"}}>Solo servicios en línea.</span></>
          ) : comercio.distancia !== "Acceso a la ubicación requerido." ? (
            <>A <b>{comercio.distancia}</b> de tu ubicación actual.</>
          ) : (
            <>Acceso a la ubicación requerido.</>
          )}
        </p>
      </div>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleToggleSeguir(comercio.id);
        }}
        className={`follow-btn ${estaLogueado && seguidoBool ? "btn-followed" : "btn-follow"}`}
      >
        {estaLogueado && seguidoBool ? "Seguido" : "Seguir"}
      </button>
    </div>
  );
};

export default SugerenciaItem;
